import { render, staticRenderFns } from "./FilesDownload.vue?vue&type=template&id=62390a52&scoped=true"
import script from "./FilesDownload.vue?vue&type=script&lang=js"
export * from "./FilesDownload.vue?vue&type=script&lang=js"
import style0 from "./FilesDownload.vue?vue&type=style&index=0&id=62390a52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62390a52",
  null
  
)

export default component.exports